import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.customIngredients;

export default class CustomIngredients extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.increment(1),
      name: this.string(''),
      type: this.string(''),
      target: this.attr(0),
      result: this.attr(0),
    };
  }
}
